import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoLiberacaoRemotaConsulta({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operacaoliberacaoremotaconsulta', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoLiberacaoRemotaConsulta({ payload }) {
  try {
    const { idoperacaoabastecimento, params } = payload;

    yield call(
      api.delete,
      `operacaoliberacaoremotaconsulta/${idoperacaoabastecimento}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoliberacaoremotaconsulta, params } = payload;

    yield call(
      api.post,
      'operacaoliberacaoremotaconsulta',
      operacaoliberacaoremotaconsulta
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    //history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { movi_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaoliberacaoremotaconsulta/${movi_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoliberacaoremotaconsulta, params } = payload;

    yield call(
      api.put,
      'operacaoliberacaoremotaconsulta',
      operacaoliberacaoremotaconsulta
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'operacaoliberacaoremotaconsulta', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoliberacaoremotaconsulta/OPERACAOLIBERACAOREMOTACONSULTA_IN_REQUEST',
    requestOperacaoLiberacaoRemotaConsulta
  ),
  takeLatest(
    '@operacaoliberacaoremotaconsulta/DELETE_OPERACAOLIBERACAOREMOTACONSULTA',
    deleteOperacaoLiberacaoRemotaConsulta
  ),
  takeLatest(
    '@operacaoliberacaoremotaconsulta/SUCCESS_REMOVE',
    requestOperacaoLiberacaoRemotaConsulta
  ),
  takeLatest(
    '@operacaoliberacaoremotaconsulta/STORE_OPERACAOLIBERACAOREMOTACONSULTA',
    store
  ),
  takeLatest(
    '@operacaoliberacaoremotaconsulta/FIND_OPERACAOLIBERACAOREMOTACONSULTA',
    find
  ),
  takeLatest(
    '@operacaoliberacaoremotaconsulta/UPDATE_OPERACAOLIBERACAOREMOTACONSULTA',
    update
  ),
  takeLatest(
    '@operacaoliberacaoremotaconsulta/RECORD_FILTERING',
    applyedFilters
  ),
]);
